import { NewPriceFormValues, ResidualValueFormValues, UsedPriceFormValues } from "./types";

export const initialResidualValueFormValues: ResidualValueFormValues = {
  jom: "",
  priceOnDate: null,
  firstRegistrationDate: null,
  usedVehicle: false,
  manualPriceEntry: false,
  mileageKm: null,
  mileageAtContractEnd: null,
  financingStartDate: null,
  contractEndDate: null,
  invoicePrice: null,
  ppmvByInvoice: null,
  co2: null,
  numberOfSeats: null,
  electricRange: null,
  enginePower: null,
  engineDisplacement: null,
  ecoProgramId: null,
  ppmvPassengerVehicles: false,
  additionalEquipmentFreeText: null,
  additionalEquipmentFreePrice: null,
  additionalEquipment: [],
};

export const initialNewPriceFormValues: NewPriceFormValues = {
  jom: "",
  priceOnDate: null,
  firstRegistrationDate: null,
  co2: null,
  numberOfSeats: null,
  electricRange: null,
  enginePower: null,
  engineDisplacement: null,
  ecoProgramId: null,
  deduction50PercentVAT: false,
  ppmvPassengerVehicles: false,
  additionalEquipmentFreeText: null,
  additionalEquipmentFreePrice: null,
  additionalEquipment: [],
};

export const initialUsedPriceFormValues: UsedPriceFormValues = {
  jom: "",
  priceOnDate: null,
  firstRegistrationDate: null,
  mileageKm: null,
  co2: null,
  numberOfSeats: null,
  electricRange: null,
  enginePower: null,
  engineDisplacement: null,
  ecoProgramId: null,
  ppmvPassengerVehicles: false,
  additionalEquipmentFreeText: null,
  additionalEquipmentFreePrice: null,
  additionalEquipment: [],
};
